/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1PersonIdAdditionalDataMutationRequest,
  PutApiV1PersonIdAdditionalDataMutationResponse,
  PutApiV1PersonIdAdditionalDataPathParams,
  PutApiV1PersonIdAdditionalData400,
  PutApiV1PersonIdAdditionalData401,
  PutApiV1PersonIdAdditionalData404,
  PutApiV1PersonIdAdditionalData500,
} from "../../types/personRegisterController/PutApiV1PersonIdAdditionalData.ts";

function getPutApiV1PersonIdAdditionalDataUrl(
  id: PutApiV1PersonIdAdditionalDataPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/person/${id}/additional-data` as const,
  };
  return res;
}

/**
 * @description Atualiza parcialmente os dados adicionais de uma pessoa. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados adicionais (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/additional-data}
 */
export async function putApiV1PersonIdAdditionalData(
  id: PutApiV1PersonIdAdditionalDataPathParams["id"],
  data?: PutApiV1PersonIdAdditionalDataMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1PersonIdAdditionalDataMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1PersonIdAdditionalDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdAdditionalData400
      | PutApiV1PersonIdAdditionalData401
      | PutApiV1PersonIdAdditionalData404
      | PutApiV1PersonIdAdditionalData500
    >,
    PutApiV1PersonIdAdditionalDataMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1PersonIdAdditionalDataUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
